// apps/landing-page/src/components/search/PageSearchInput.tsx
// The big white search box in a teal page header (/tests and /cari). No 'use client': the
// /tests server shell renders it too. Without onChange it is uncontrolled.
import { Search } from 'lucide-react';

interface PageSearchInputProps {
  value: string;
  onChange?: (value: string) => void;
  label: string;
  placeholder: string;
}

export function PageSearchInput({ value, onChange, label, placeholder }: PageSearchInputProps) {
  return (
    <div className="relative mt-5 max-w-2xl">
      <Search aria-hidden="true" className="pointer-events-none absolute left-4 top-1/2 h-5 w-5 -translate-y-1/2 text-slate-400" />
      <input
        type="search"
        aria-label={label}
        placeholder={placeholder}
        autoComplete="off"
        {...(onChange
          ? { value, onChange: (e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.value) }
          : { defaultValue: value })}
        // outline-none!: globals.css has an unlayered :focus-visible outline that beats plain utilities.
        className="h-14 w-full rounded-2xl bg-white pl-12 pr-4 text-[16px] text-slate-900 placeholder:text-slate-400 outline-none! focus-visible:ring-4 focus-visible:ring-teal-300"
      />
    </div>
  );
}
